"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminContentReportListItemDto = exports.AdminContentReportTargetDto = exports.AdminContentReportDto = exports.AdminContentReportReporterDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class AdminContentReportReporterDto {}
exports.AdminContentReportReporterDto = AdminContentReportReporterDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminContentReportReporterDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminContentReportReporterDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminContentReportReporterDto.prototype, "lastName", void 0);
/** One user's report of a Note or Moment, shown to admins next to the flagged item. */
class AdminContentReportDto {}
exports.AdminContentReportDto = AdminContentReportDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminContentReportDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.ContentReportTargetType
}), __metadata("design:type", String)], AdminContentReportDto.prototype, "targetType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'publicId of the reported note (breadcrumb) or moment (sticker).'
}), __metadata("design:type", String)], AdminContentReportDto.prototype, "targetPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminContentReportDto.prototype, "reason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.ContentReportStatus
}), __metadata("design:type", String)], AdminContentReportDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminContentReportDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminContentReportDto.prototype, "resolvedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminContentReportReporterDto
}), __metadata("design:type", AdminContentReportReporterDto)], AdminContentReportDto.prototype, "reporter", void 0);
/** What a reported note or moment looks like, for the admin "Reported" list. */
class AdminContentReportTargetDto {}
exports.AdminContentReportTargetDto = AdminContentReportTargetDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Note text, or the moment caption.'
}), __metadata("design:type", Object)], AdminContentReportTargetDto.prototype, "text", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Moment photo; null for notes.'
}), __metadata("design:type", Object)], AdminContentReportTargetDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminContentReportTargetDto.prototype, "authorPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminContentReportTargetDto.prototype, "authorName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminContentReportTargetDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Deleted by its author or an admin since the report.'
}), __metadata("design:type", Boolean)], AdminContentReportTargetDto.prototype, "isDeleted", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminContentReportTargetDto.prototype, "isFlagged", void 0);
class AdminContentReportListItemDto extends AdminContentReportDto {}
exports.AdminContentReportListItemDto = AdminContentReportListItemDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminContentReportTargetDto
}), __metadata("design:type", AdminContentReportTargetDto)], AdminContentReportListItemDto.prototype, "target", void 0);
//# sourceMappingURL=AdminContentReport.dto.js.map